/**
 * Name correction (PG-14, mailed since NT-14): the customer page that fixes a wrong company or owner
 * name on the IRS record. The route wraps the page; the services page and the sidebar link to its path.
 */
export const EIN_CORRECTION_HREF = '/ein-correction'

/** The company's landing read (availability included), for the services card. */
export { formatPrice as formatEinCorrectionPrice } from './lib/format'
export { useEinCorrection } from './lib/use-ein-correction'
